const delayMs = 50;

function forceEagerLoading(imgNode) {
  if (imgNode === undefined || imgNode === null) {
    return;
  }
  if (imgNode.dataset.src === 'loaded') {
    return;
  }
  loadImage(imgNode);
}

function loadImage(imgNode) {
  imgNode.src = imgNode.dataset.src;
  imgNode.dataset.src = 'loaded';
}

function delayImageLoading(imgNodes) {
  let index = 0;

  function next() {
    if (index >= imgNodes.length) {
      return;
    }

    forceEagerLoading(imgNodes[index]);
    index++;
    setTimeout(next, delayMs);
  }

  next();
}

window.addEventListener('load', () => {
  delayImageLoading(document.querySelectorAll('.product-configurator__toothimg.lazyimg'));
});